import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PaycycleFormEdit from './feedback-form/feedback-form-edit';
import PaycycleFormView from './feedback-form/feedback-form-view';
import { CommonSevice } from '../../../../services/common';
import {
  FormFieldTypes,
  LoadingStatus,
  ToastThemes,
} from '../../../../constants/common';
import { showToast } from '../../../../utils/common.util';
import TryAgain from '../../../molecules/ErrorState/error.component';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';

const AddSalaryComponent = (props) => {
  const {
    viewMode,
    setViewMode,
    payCycleId,
    setShowForm,
    setPayCycleId,
    moduleId,
  } = props;
  const { currentUserRoleId } = useSelector((state) => state.main);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(-1);

  useEffect(async () => {
    if (currentUserRoleId) {
      if (payCycleId) {
        setLoading(LoadingStatus.Loading);
        await new CommonSevice()
          .getFeedbackDetails(payCycleId)
          .then((res) => {
            setFormData(res);
            setLoading(LoadingStatus.Success);
            setViewMode(true);
          })
          .catch((err) => {
            showToast(err?.response?.data?.message, ToastThemes.error);
            setLoading(LoadingStatus.Failure);
            throw err?.response?.data?.message;
          });
      }
    }
    return () => {
      setViewMode(false);
    };
  }, [payCycleId, currentUserRoleId]);

  if (loading === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <>
      <CircularLoader show={loading === LoadingStatus.Loading && payCycleId} />
      {/* {loading === LoadingStatus.Success && viewMode ? ( */}
      <PaycycleFormView
        formConfig={formConfig}
        setViewMode={setViewMode}
        isNew={!payCycleId}
        formData={formData}
        setShowForm={setShowForm}
      />
      {/* ) : (
        <PaycycleFormEdit
          formConfig={fieldsForClaimCategories}
          setViewMode={setViewMode}
          formData={formData}
          isNew={!payCycleId}
          setShowForm={setShowForm}
          payCycleId={payCycleId}
          setPayCycleId={setPayCycleId}
          moduleId={moduleId}
        />
      )} */}
    </>
  );
};

export default AddSalaryComponent;

const formConfig = [
  {
    fieldLabel: 'Rating',
    placeholderText: 'Select Option',
    fieldType: FormFieldTypes.Text,
    isRequired: true,
    fieldRefName: 'rating',
    fieldSize: 6,
    tooltipText: 'Ratings range from 1 (lowest) to 5 (highest)',
  },
  {
    fieldLabel: 'Feedback Option',
    placeholderText: 'Select Option',
    fieldType: FormFieldTypes.SingleSelect,
    isRequired: true,
    fieldRefName: 'optionId',
    fieldSize: 6,
  },
  {
    fieldLabel: 'Module',
    placeholderText: 'Select Option',
    fieldType: FormFieldTypes.SingleSelect,
    isRequired: true,
    fieldRefName: 'moduleId',
    fieldSize: 6,
  },
  {
    fieldLabel: 'Sub Module(Form)',
    placeholderText: 'Select Option',
    fieldType: FormFieldTypes.SingleSelect,
    isRequired: true,
    fieldRefName: 'formId',
    fieldSize: 6,
  },
  {
    fieldLabel: 'Remarks',
    fieldType: FormFieldTypes.Text,
    dataType: FormFieldTypes.MultiLineText,
    isRequired: true,
    fieldRefName: 'remarks',
    fieldSize: 6,
  },
  {
    fieldLabel: 'User Role',
    placeholderText: 'Select Option',
    fieldType: FormFieldTypes.SingleSelect,
    isRequired: true,
    fieldRefName: 'roleId',
    fieldSize: 6,
  },
  {
    fieldLabel: 'Submission Date',
    fieldType: FormFieldTypes.DateTime,
    isRequired: false,
    fieldRefName: 'createdUtc',
    fieldSize: 6,
  },
  {
    fieldLabel: 'Supporting Document',
    placeholderText: 'Upload in PNG, JPEG or PDF format',
    fieldType: FormFieldTypes.File,
    isRequired: false,
    fieldRefName: 'attachment',
    fieldSize: 6,
  },
];
